<template>
  <v-alert 
    type="error" 
    class="roundedcard"
    style="overflow: scroll;"
    dismissible 
    :value="true"
    transition="scale-transition"
    @input="onClose">
    {{ text }}
  </v-alert>
</template>


<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  methods: {
    onClose() {
      this.$emit('dismissed')
    }
  }
}
</script>
